const procedures = [
   {
    title: "Earlobe Repair & Piercing",
    slug: "earlobe-repair-piercing",
    short: "Restore torn earlobes or get precise piercings.",
    category: "Dermato Surgery",
    image: "/Images/earlobe.webp",
    intro: "We offer both cosmetic repair of damaged earlobes and hygienic ear piercing services.",
    whatWeDo: [
      {
        step: "Assessment",
        description: "Examine earlobe condition and recommend procedure.",
        image: "/Images/assessment.webp"
      },
      {
        step: "Surgical Repair or Piercing",
        description: "Perform repair or hygienic piercing.",
        image: "/Images/repair.webp"
      },
      {
        step: "Healing Support",
        description: "Post-procedure care for smooth recovery.",
        image: "/Images/healing.webp"
      }
    ],
     surgeryimg:["/Images/procedure-offered/Earlobe/s1.webp","/Images/procedure-offered/Earlobe/s2.webp"
     ],
    procedures: [
      { name: "Earlobe Stitch Repair", description: "Suturing torn earlobes for normal shape." },
      { name: "Piercing", description: "Safe, sterile ear piercing with minimal pain." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
    aftercare: [
      { title: "Keep Dry", description: "Avoid water for initial days.", image: "/Images/keep-dry.webp" },
      { title: "Apply Antibiotic", description: "Use prescribed cream for healing.", image: "/Images/antibiotic.webp" },
      { title: "No Pulling", description: "Avoid touching or pulling earrings.", image: "/Images/no-pull.webp" }
    ],
    faqs: [
      { question: "Is stitching painful?", answer: "Minimal discomfort with numbing." },
      { question: "Can I wear earrings again?", answer: "Yes, after full healing." },
      { question: "How long to heal?", answer: "2-3 weeks typically." }
    ],
    beforeAfter: {
      beforeImage: "/Images/procedure-offered/Earlobe/b.webp",
      afterImage: "/Images/procedure-offered/Earlobe/a.webp"
    }
  },
   {
    title: "Skin Tag Removal",
    slug: "skin-tag-removal",
    short: "Quick removal of skin tags with minimal discomfort.",
    category: "Dermato Surgery",
    image: "/Images/skin-tag.webp",
    intro: "We offer safe and effective methods to remove skin tags quickly and comfortably.",
    whatWeDo: [
      {
        step: "Consultation",
        description: "Evaluate size, location, and best removal technique.",
        image: "/Images/consultation.webp"
      },
      {
        step: "Removal",
        description: "Use laser, cautery or excision for painless removal.",
        image: "/Images/removal.webp"
      },
      {
        step: "Post-Treatment Care",
        description: "Provide care instructions for smooth healing.",
        image: "/Images/post-care.webp"
      }
    ],
    procedures: [
      { name: "Laser Ablation", description: "Non-invasive precise removal." },
      { name: "Electrocautery", description: "Heat-based instant removal." },
      { name: "Excision", description: "Small surgical removal for larger tags." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
    surgeryimg:["/Images/procedure-offered/Skin Tag/s1.webp","/Images/procedure-offered/Skin Tag/s2.webp"
     ],
    aftercare: [
      { title: "Gentle Cleaning", description: "Keep area clean daily.", image: "/Images/cleaning.webp" },
      { title: "Avoid Irritation", description: "Do not scratch or rub area.", image: "/Images/irritation.webp" },
      { title: "Follow-up Visit", description: "Routine check for healing.", image: "/Images/followup.webp" }
    ],
    faqs: [
      { question: "Any scarring?", answer: "Minimal with proper care." },
      { question: "Can skin tags recur?", answer: "Possible; treated ones won't return." },
      { question: "Is it permanent?", answer: "Removed tags are gone permanently." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-skin-tag.webp",
    //   afterImage: "/Images/after-skin-tag.webp"
    // }
  },
 {
  title: "Wound Cure",
  slug: "wound-cure",
  short: "Safe and effective wound care for quick recovery.",
  category: "Dermato Surgery",
  image: "/Images/wound-care.webp",
  intro: "At Dr Nidhi Patel’s Skin Clinic, we provide advanced wound care to promote healing and prevent infection.",
  whatWeDo: [
    {
      step: "Pre-consultation",
      description: "Assessment of wound size, depth, and appropriate treatment planning.",
      image: "/Images/pre-consultation.webp"
    },
    {
      step: "Cleaning & Dressing",
      description: "Thorough cleaning, debridement if needed, and sterile dressing application.",
      image: "/Images/removal.webp"
    },
    {
      step: "Post Care",
      description: "Regular monitoring, dressing changes, and guidance on healing.",
      image: "/Images/post-care.webp"
    }
  ],
  // surgeryimg: "",
  procedures: [
    { name: "Cleaning & Dressing", description: "Sterile cleaning to prevent infection and promote healing." },
    { name: "Debridement", description: "Removal of dead tissue for better wound healing." },
    { name: "Advanced Dressings", description: "Use of specialized dressings to support fast healing." }
  ],
  doctor: {
    name: "Dr Nidhi Patel",
    experience: "100% Experience",
    patientSuccess: "100% Patient Success Rate",
    expertise: "100% Procedures Expertise",
    knowledge: "100% Knowledge",
    image: "/Images/procedure/doctor-nidhi.webp"
  },
  aftercare: [
    { title: "Keep Area Clean", description: "Maintain hygiene to avoid infection.", image: "/Images/clean-dry.webp" },
    { title: "Follow Up Visits", description: "Timely check-ups to monitor progress.", image: "/Images/ointment.webp" },
    { title: "Avoid Trauma", description: "Protect wound area from further injury.", image: "/Images/no-pick.webp" }
  ],
  faqs: [
    { question: "Is it painful?", answer: "Minimal discomfort with proper care." },
    { question: "Healing time?", answer: "Varies based on wound severity." },
    { question: "Chance of complications?", answer: "Rare with proper management." }
  ],
  beforeAfter: {
    beforeImage: "/Images/procedure-offered/Wound_cure/b.webp",
    afterImage: "/Images/procedure-offered/Wound_cure/a.webp"
  }
},
{
  title: "Wart/Corn Removal",
  slug: "wart-corn-removal",
  short: "Safe and effective removal of warts and corns to restore smooth skin.",
  category: "Dermato Surgery",
  image: "/Images/wart-corn.webp",
  intro: "At Dr Nidhi Patel’s Skin Clinic we provide advanced treatments for wart and corn removal with minimal discomfort and quick recovery.",
  whatWeDo: [
    {
      step: "Initial Evaluation",
      description: "Detailed assessment of the wart/corn type, size, and location to determine the best treatment approach.",
      image: "/Images/pre-consultation-wart.webp"
    },
    {
      step: "Removal Procedure",
      description: "Effective removal using cryotherapy, laser, or minor surgical techniques depending on the case.",
      image: "/Images/wart-removal.webp"
    },
    {
      step: "Post Treatment Care",
      description: "Guidance to prevent recurrence and ensure smooth healing.",
      image: "/Images/post-care-wart.webp"
    }
  ],
  procedures: [
    { name: "Cryotherapy", description: "Freezing the wart/corn using liquid nitrogen." },
    { name: "Laser Treatment", description: "Precise laser removal with minimal scarring." },
    { name: "Minor Surgical Excision", description: "Removal with minor surgery for stubborn cases." }
  ],
  doctor: {
    name: "Dr Nidhi Patel",
    experience: "100% Experience",
    patientSuccess: "100% Patient Success Rate",
    expertise: "100% Procedures Expertise",
    knowledge: "100% Knowledge",
    image: "/Images/procedure/doctor-nidhi.webp"
  },
   surgeryimg:["/Images/procedure-offered/Wart Corn/s1.webp"],
  aftercare: [
    { title: "Keep Clean & Dry", description: "Maintain hygiene to prevent infection.", image: "/Images/clean-dry.webp" },
    { title: "Apply Medication", description: "Use prescribed topical treatments regularly.", image: "/Images/ointment.webp" },
    { title: "Avoid Pressure", description: "Reduce pressure on treated area until fully healed.", image: "/Images/no-pressure.webp" }
  ],
  faqs: [
    { question: "Is wart/corn removal painful?", answer: "Minimal pain with proper anesthesia and care." },
    { question: "How long does healing take?", answer: "Typically 1-2 weeks depending on size and depth." },
    { question: "Can warts/corns recur?", answer: "Proper treatment minimizes recurrence, but follow-up may be needed." }
  ],
  beforeAfter: {
    beforeImage: "/Images/procedure-offered/Wart Corn/b.webp",
    afterImage: "/Images/procedure-offered/Wart Corn/a.webp"
  }
}

,
{
    title: "Vitiligo Surgery",
    slug: "vitiligo-surgery",
    short: "Surgical correction for stable vitiligo patches.",
    category: "Dermato Surgery",
    image: "/Images/vitiligo.webp",
    intro: "We provide specialized surgical options to restore pigment in stable vitiligo cases.",
    whatWeDo: [
      {
        step: "Assessment",
        description: "Check stability & suitability for surgery.",
        image: "/Images/assessment.webp"
      },
      {
        step: "Grafting Procedure",
        description: "Perform skin graft or melanocyte transfer.",
        image: "/Images/grafting.webp"
      },
      {
        step: "Post-op Care",
        description: "Monitor healing and pigment restoration.",
        image: "/Images/post-op.webp"
      }
    ],
    procedures: [
      { name: "Split Thickness Grafting", description: "Transfer of pigmented skin layers." },
      { name: "Melanocyte Transfer", description: "Cell transfer for repigmentation." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
      surgeryimg:["/Images/procedure-offered/Vitiligo_S/s1.webp","/Images/procedure-offered/Vitiligo_S/s2.webp","/Images/procedure-offered/Vitiligo_S/s3.webp","/Images/procedure-offered/Vitiligo_S/s4.webp"],
    aftercare: [
      { title: "Protect Area", description: "Keep graft area safe from trauma.", image: "/Images/protect.webp" },
      { title: "Use Creams", description: "Apply prescribed repigmenting creams.", image: "/Images/cream.webp" },
      { title: "Sun Exposure", description: "Controlled sunlight for pigment activation.", image: "/Images/sun.webp" }
    ],
    faqs: [
      { question: "Is vitiligo surgery permanent?", answer: "Pigment can be restored; follow-up may be needed." },
      { question: "Any downtime?", answer: "Short recovery period depending on size." },
      { question: "Who is eligible?", answer: "Stable, non-spreading vitiligo cases." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-vitiligo.webp",
    //   afterImage: "/Images/after-vitiligo.webp"
    // }
  },
    {
    title: "DPN Removal",
    slug: "dpn-removal",
    short: "Precise removal of DPN lesions with minimal downtime.",
    category: "Dermato Surgery",
    image: "/Images/dpn.webp",
    intro: "We specialize in safe removal of dermatosis papulosa nigra (DPN) for smoother skin.",
    whatWeDo: [
      {
        step: "Diagnosis",
        description: "Confirm DPN spots suitable for removal.",
        image: "/Images/diagnosis.webp"
      },
      {
        step: "Removal",
        description: "Perform laser or electrocautery removal.",
        image: "/Images/removal.webp"
      },
      {
        step: "Post Care",
        description: "Guidance for skin recovery and prevention.",
        image: "/Images/post-care.webp"
      }
    ],
    procedures: [
      { name: "Laser Removal", description: "Non-invasive laser vaporization." },
      { name: "Electrocautery", description: "Controlled heat for quick removal." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/DPN/s1.webp"],
    aftercare: [
      { title: "Moisturize", description: "Apply gentle moisturizer daily.", image: "/Images/moisturize.webp" },
      { title: "Sun Protection", description: "Apply SPF regularly.", image: "/Images/sunscreen.webp" },
      { title: "Gentle Cleansing", description: "Avoid harsh products.", image: "/Images/gentle.webp" }
    ],
    faqs: [
      { question: "How many sessions?", answer: "Usually 1 session sufficient." },
      { question: "Will spots return?", answer: "Removed spots don't return; new ones may appear with age." },
      { question: "Is downtime needed?", answer: "Minimal or no downtime." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-dpn.webp",
    //   afterImage: "/Images/after-dpn.webp"
    // }
  },
{
  title: "Keloid Surgery",
  slug: "keloid-surgery",
  short: "Effective treatment for keloid scars with advanced techniques.",
  category: "Dermato Surgery",
  image: "/Images/keloid.webp",
  intro: "At Dr Nidhi Patel’s Skin Clinic, we offer precise keloid removal with a combination of surgical and non-surgical approaches to minimize recurrence.",
  whatWeDo: [
    {
      step: "Assessment",
      description: "Evaluation of keloid size, depth, and treatment suitability.",
      image: "/Images/pre-consultation.webp"
    },
    {
      step: "Surgical Removal",
      description: "Excision of keloid tissue followed by adjunct therapy to reduce recurrence.",
      image: "/Images/removal.webp"
    },
    {
      step: "Post Care",
      description: "Guidance on healing, scar care, and prevention of regrowth.",
      image: "/Images/post-care.webp"
    }
  ],
  procedures: [
    { name: "Surgical Excision", description: "Precise removal of keloid tissue." },
    { name: "Intralesional Steroid", description: "Injections to prevent recurrence post-removal." },
    { name: "Laser Therapy", description: "Laser sessions to improve skin texture and flatten scars." },
    { name: "Silicone Gel Therapy", description: "Post-operative application to minimize new keloid formation." }
  ],
  doctor: {
    name: "Dr Nidhi Patel",
    experience: "100% Experience",
    patientSuccess: "100% Patient Success Rate",
    expertise: "100% Procedures Expertise",
    knowledge: "100% Knowledge",
    image: "/Images/procedure/doctor-nidhi.webp"
  },
  surgeryimg:["/Images/procedure-offered/Keloid_S/s1.webp"],
  aftercare: [
    { title: "Avoid Sun Exposure", description: "Protect treated area from UV rays.", image: "/Images/clean-dry.webp" },
    { title: "Follow Up Injections", description: "Attend scheduled steroid sessions.", image: "/Images/ointment.webp" },
    { title: "Gentle Massage", description: "Light massage may help soften scar tissue.", image: "/Images/no-pick.webp" }
  ],
  faqs: [
    { question: "Will it come back?", answer: "Proper post-care significantly reduces recurrence." },
    { question: "Is the procedure painful?", answer: "Minimal pain with anesthesia and proper care." },
    { question: "How long is recovery?", answer: "Healing typically occurs over 2-3 weeks." }
  ],
  beforeAfter: {
    beforeImage: "/Images/procedure-offered/Keloid_S/b.webp",
    afterImage: "/Images/procedure-offered/Keloid_S/a.webp"
  }
}
,{
  title: "Acne Scar Surgery",
  slug: "acne-scar-surgery",
  short: "Advanced treatment options to reduce acne scars and improve skin texture.",
  category: "Dermato Surgery",
  image: "/Images/acne-scar.webp",
  intro: "At Dr Nidhi Patel’s Skin Clinic, we combine multiple modalities to effectively treat acne scars and restore skin smoothness.",
  whatWeDo: [
    {
      step: "Initial Consultation",
      description: "Assessment of scar type and depth to plan combination therapy.",
      image: "/Images/pre-consultation.webp"
    },
    {
      step: "Scar Revision Procedures",
      description: "Customized approach using subcision, laser, microneedling or fillers.",
      image: "/Images/removal.webp"
    },
    {
      step: "Post Care",
      description: "Skin care regimen for optimal healing and long-term results.",
      image: "/Images/post-care.webp"
    }
  ],
  procedures: [
    { name: "Subcision", description: "Releasing fibrous bands under depressed scars." },
    { name: "Microneedling RF", description: "Collagen induction for smoother skin texture." },
    { name: "Laser Resurfacing", description: "Precise skin resurfacing to reduce scar depth." },
    { name: "Dermal Fillers", description: "Filling deeper pitted scars for immediate improvement." }
  ],
  doctor: {
    name: "Dr Nidhi Patel",
    experience: "100% Experience",
    patientSuccess: "100% Patient Success Rate",
    expertise: "100% Procedures Expertise",
    knowledge: "100% Knowledge",
    image: "/Images/procedure/doctor-nidhi.webp"
  },
   surgeryimg:["/Images/procedure-offered/Acne_Scar/s1.webp"],
  aftercare: [
    { title: "Sun Protection", description: "Use sunscreen regularly.", image: "/Images/clean-dry.webp" },
    { title: "Hydration", description: "Keep skin well moisturized.", image: "/Images/ointment.webp" },
    { title: "Avoid Picking", description: "Do not disturb healing skin.", image: "/Images/no-pick.webp" }
  ],
  faqs: [
    { question: "How many sessions are needed?", answer: "Depends on scar severity; usually multiple sessions." },
    { question: "Is it painful?", answer: "Mild discomfort with topical anesthesia." },
    { question: "How soon will I see results?", answer: "Gradual improvement over several weeks." }
  ],
  // beforeAfter: {
  //   beforeImage: "/Images/before-acne-scar.webp",
  //   afterImage: "/Images/after-acne-scar.webp"
  // }
}
,
  

  
  
    {
    title: "PRP & GFC Hair Treatment",
    slug: "prp-gfc-hair-treatment",
    short: "Stimulate natural hair growth using advanced platelet-based therapies.",
    category: "Hair Treatment",
    image: "/Images/prp-gfc.webp",
    intro: "We provide PRP and GFC therapies for hair fall control, hair thinning and hair regrowth using your body's natural growth factors.",
    whatWeDo: [
      {
        step: "Assessment",
        description: "Evaluate scalp condition and suitability.",
        image: "/Images/hair-assessment.webp"
      },
      {
        step: "Blood Collection",
        description: "Draw your blood for platelet separation.",
        image: "/Images/blood-collection.webp"
      },
      {
        step: "Injection Procedure",
        description: "Inject PRP/GFC into scalp to stimulate hair growth.",
        image: "/Images/prp-injection.webp"
      }
    ],
    procedures: [
      { name: "PRP Therapy", description: "Platelet Rich Plasma extracted from your blood." },
      { name: "GFC Therapy", description: "Concentrated Growth Factors activated for better results." }
    ],
     surgeryimg:["/Images/procedure-offered/PRP/S1.webp", "/Images/procedure-offered/PRP/S2.webp"],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
    aftercare: [
      { title: "No Washing for 24 Hours", description: "Allow scalp to absorb treatment.", image: "/Images/no-wash.webp" },
      { title: "Gentle Shampoo Use", description: "Use mild shampoos only.", image: "/Images/mild-shampoo.webp" },
      { title: "Regular Sessions", description: "Complete advised sessions for best results.", image: "/Images/sessions.webp" }
    ],
    faqs: [
      { question: "Is PRP safe?", answer: "Yes, it uses your own blood." },
      { question: "When will I see results?", answer: "Noticeable results in 3-4 months." },
      { question: "Any side effects?", answer: "Minimal discomfort; no major side effects." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/procedure-offered/PRP/S1.webp",
    //   afterImage: "/Images/after-prp.webp"
    // }
  },
  {
    title: "Derma Roller Therapy",
    slug: "derma-roller",
    short: "Microneedling therapy for hair regrowth and skin rejuvenation.",
    category: "Hair Treatment",
    image: "/Images/derma-roller.webp",
    intro: "Derma roller microneedling promotes collagen and hair follicle stimulation naturally.",
    whatWeDo: [
      {
        step: "Consultation",
        description: "Examine scalp condition for microneedling suitability.",
        image: "/Images/derma-consult.webp"
      },
      {
        step: "Microneedling Session",
        description: "Perform controlled rolling to stimulate scalp.",
        image: "/Images/microneedling.webp"
      },
      {
        step: "Serum Application",
        description: "Apply nourishing serum post-treatment.",
        image: "/Images/serum.webp"
      }
    ],
    procedures: [
      { name: "Microneedling Therapy", description: "Use of micro needles to stimulate growth." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/Derma_Roller/s1.webp"],
    aftercare: [
      { title: "Avoid Sun", description: "Protect treated scalp from sunlight.", image: "/Images/no-sun.webp" },
      { title: "No Harsh Products", description: "Use only doctor-recommended products.", image: "/Images/no-harsh.webp" },
      { title: "Moisturize", description: "Keep scalp hydrated.", image: "/Images/moisture.webp" }
    ],
    faqs: [
      { question: "Is it painful?", answer: "Mild discomfort; numbing cream used." },
      { question: "Any downtime?", answer: "No major downtime." },
      { question: "When will I see regrowth?", answer: "Visible changes after few sessions." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-derma.webp",
    //   afterImage: "/Images/after-derma.webp"
    // }
  },
  {
    title: "Chemical Peeling",
    slug: "chemical-peeling",
    short: "Peel away dead skin cells for brighter, smoother skin.",
    category: "Cosmetic Procedure",
    image: "/Images/chemical-peel.webp",
    intro: "We offer medical-grade chemical peels to treat acne, pigmentation, scars, and dull skin.",
    whatWeDo: [
      {
        step: "Skin Evaluation",
        description: "Determine right type of peel for your skin.",
        image: "/Images/skin-eval.webp"
      },
      {
        step: "Peeling Session",
        description: "Apply chemical solution for controlled exfoliation.",
        image: "/Images/peeling.webp"
      },
      {
        step: "Post-Peel Care",
        description: "Moisturize and protect skin after peeling.",
        image: "/Images/post-peel.webp"
      }
    ],
    procedures: [
      { name: "Light Peel", description: "Mild acids for subtle glow." },
      { name: "Medium Peel", description: "Deeper exfoliation for scars & pigmentation." },
      { name: "Deep Peel", description: "Strongest peel for stubborn spots." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
    surgeryimg:["/Images/procedure-offered/chemical_peeling/s1.webp","/Images/procedure-offered/chemical_peeling/s2.webp"],
    aftercare: [
      { title: "Sun Protection", description: "Strict sun avoidance & SPF use.", image: "/Images/sunblock.webp" },
      { title: "Hydration", description: "Apply moisturizer daily.", image: "/Images/moisture.webp" },
      { title: "Avoid Makeup", description: "No makeup for few days.", image: "/Images/no-makeup.webp" }
    ],
    faqs: [
      { question: "Is peeling painful?", answer: "Mild tingling only." },
      { question: "How many sessions?", answer: "Usually 3-6 for best results." },
      { question: "Downtime?", answer: "Minimal downtime." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-peel.webp",
    //   afterImage: "/Images/after-peel.webp"
    // }
  },
  {
    title: "Laser Hair Reduction",
    slug: "laser-hair-reduction",
    short: "Permanent hair reduction using advanced laser technology.",
    category: "Cosmetic Procedure",
    image: "/Images/laser-hair.webp",
    intro: "Safe & effective laser hair removal for smooth skin without frequent shaving or waxing.",
    whatWeDo: [
      {
        step: "Skin Assessment",
        description: "Evaluate skin & hair type for suitable laser settings.",
        image: "/Images/laser-assessment.webp"
      },
      {
        step: "Laser Treatment",
        description: "Perform laser shots on target area.",
        image: "/Images/laser-session.webp"
      },
      {
        step: "Post Care",
        description: "Soothe skin & protect from sun.",
        image: "/Images/laser-care.webp"
      }
    ],
    procedures: [
      { name: "Full Body Laser", description: "Complete body hair removal." },
      { name: "Facial Laser", description: "For facial hair concerns." },
      { name: "Underarms & Bikini", description: "Sensitive area safe treatment." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/lazer_hair/s1.webp","/Images/procedure-offered/lazer_hair/s2.webp"],
    aftercare: [
      { title: "No Sun Exposure", description: "Protect from direct sun.", image: "/Images/sunblock.webp" },
      { title: "Gentle Cooling", description: "Use soothing creams.", image: "/Images/cooling.webp" },
      { title: "Avoid Waxing", description: "No waxing/plucking between sessions.", image: "/Images/no-wax.webp" }
    ],
    faqs: [
      { question: "How many sessions?", answer: "Usually 6-8 sessions needed." },
      { question: "Is it permanent?", answer: "Long-term reduction achieved." },
      { question: "Is laser painful?", answer: "Mild discomfort only." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-laser.webp",
    //   afterImage: "/Images/after-laser.webp"
    // }
  },
  {
    title: "Facial Rejuvenation (Hydra + Vampire + Carbon Facial)",
    slug: "facial-rejuvenation-combo",
    short: "Advanced facial treatments for glowing, youthful skin.",
    category: "Cosmetic Procedure",
    image: "/Images/facial-combo.webp",
    intro: "We offer combination facial therapies - HydraFacial, Vampire PRP Facial and Carbon Facial for deep cleansing, rejuvenation and anti-aging effects.",
    whatWeDo: [
      {
        step: "Skin Analysis",
        description: "Evaluate skin concerns and select suitable combination.",
        image: "/Images/skin-analysis.webp"
      },
      {
        step: "Facial Procedure",
        description: "Perform combined multi-step facial treatment.",
        image: "/Images/facial-procedure.webp"
      },
      {
        step: "Post Care",
        description: "Apply soothing masks and sun protection.",
        image: "/Images/post-facial.webp"
      }
    ],
    procedures: [
      { name: "HydraFacial", description: "Deep cleansing and hydration." },
      { name: "Vampire PRP Facial", description: "PRP infusion for collagen boost." },
      { name: "Carbon Laser Facial", description: "Deep pore cleansing & instant glow." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/facial/s1.webp","/Images/procedure-offered/facial/s2.webp"],
    aftercare: [
      { title: "Hydration", description: "Keep skin moisturized.", image: "/Images/moisture.webp" },
      { title: "SPF Protection", description: "Strict sunscreen use.", image: "/Images/sunscreen.webp" },
      { title: "Gentle Cleansing", description: "Use mild cleansers only.", image: "/Images/gentle-cleanse.webp" }
    ],
    faqs: [
      { question: "Is it painful?", answer: "Comfortable, relaxing procedure." },
      { question: "Any downtime?", answer: "No downtime, instant glow." },
      { question: "How often should I do?", answer: "Monthly sessions recommended." }
    ],
    // beforeAfter: {
    //   beforeImage: "/Images/before-facial.webp",
    //   afterImage: "/Images/after-facial.webp"
    // }
  },
  {
    title: "Anti-Aging Treatment",
    slug: "anti-aging-treatment",
    short: "Restore youthful appearance with scientifically proven anti-aging solutions.",
    category: "Cosmetic Procedure",
    image: "/Images/anti-aging.webp",
    intro: "Our anti-aging treatments focus on reducing fine lines, improving skin elasticity and stimulating collagen production.",
    whatWeDo: [
      { step: "Consultation", description: "Assess aging concerns and design personalized plan.", image: "/Images/consultation.webp" },
      { step: "Procedure", description: "Apply tailored anti-aging therapies including serums, RF or microneedling.", image: "/Images/procedure.webp" },
      { step: "Post Care", description: "Guide on daily skincare and follow-up schedule.", image: "/Images/post-care.webp" }
    ],
    procedures: [
      { name: "Microneedling", description: "Stimulates collagen for smoother skin." },
      { name: "Radio Frequency", description: "Tightens skin using heat energy." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/anti-ageing/s1.webp","/Images/procedure-offered/anti-ageing/s2.webp"],
    aftercare: [
      { title: "Hydration", description: "Keep skin well-moisturized.", image: "/Images/moisture.webp" },
      { title: "Sun Protection", description: "Use sunscreen diligently.", image: "/Images/sunscreen.webp" }
    ],
    faqs: [
      { question: "When will I see results?", answer: "Visible improvement after few sessions." },
      { question: "Is it safe?", answer: "Yes, performed under expert care." }
    ],
    // beforeAfter: { beforeImage: "/Images/before-antiaging.webp", afterImage: "/Images/after-antiaging.webp" }
  },
  {
    title: "Skin Tightening",
    slug: "skin-tightening",
    short: "Firm and tighten loose skin non-surgically.",
    category: "Cosmetic Procedure",
    image: "/Images/skin-tightening.webp",
    intro: "Skin tightening procedures stimulate natural collagen and elastin to give firmer, youthful skin.",
    whatWeDo: [
      { step: "Assessment", description: "Evaluate skin laxity and select best modality.", image: "/Images/skin-analysis.webp" },
      { step: "Treatment", description: "Apply RF, ultrasound or laser tightening.", image: "/Images/tightening-treatment.webp" },
      { step: "After Care", description: "Advise on maintenance and skincare.", image: "/Images/post-care.webp" }
    ],
    procedures: [
      { name: "Radio Frequency", description: "Deep heating to contract collagen." },
      { name: "Ultrasound", description: "Stimulates deep tissue tightening." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/Skin_Tightning/s1.webp"],
    aftercare: [
      { title: "No Heat Exposure", description: "Avoid sauna or hot baths for 48 hrs.", image: "/Images/no-heat.webp" },
      { title: "Gentle Skincare", description: "Use prescribed creams.", image: "/Images/creams.webp" }
    ],
    faqs: [
      { question: "Is it painful?", answer: "Mild warmth sensation only." },
      { question: "How many sessions?", answer: "Multiple sessions give optimal results." }
    ],
    // beforeAfter: { beforeImage: "/Images/before-tightening.webp", afterImage: "/Images/after-tightening.webp" }
  },
  {
    title: "Botox & Fillers",
    slug: "botox-fillers",
    short: "Smooth wrinkles and restore volume for a refreshed look.",
    category: "Cosmetic Procedure",
    image: "/Images/botox-fillers.webp",
    intro: "We provide safe Botox and dermal filler treatments for wrinkle reduction, lip enhancement and facial contouring.",
    whatWeDo: [
      { step: "Consultation", description: "Discuss concerns and plan injection areas.", image: "/Images/botox-consult.webp" },
      { step: "Injection", description: "Precise injection of Botox or fillers by expert doctor.", image: "/Images/injection.webp" },
      { step: "Aftercare", description: "Advice on post-procedure care.", image: "/Images/post-injection.webp" }
    ],
    procedures: [
      { name: "Botox", description: "Relax muscles to reduce wrinkles." },
      { name: "Fillers", description: "Add volume to lips, cheeks, under eyes." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/fillers/s2.webp","/Images/procedure-offered/fillers/s1.webp"],
    aftercare: [
      { title: "No Pressure", description: "Avoid massaging injected area.", image: "/Images/no-massage.webp" },
      { title: "Avoid Exercise", description: "No strenuous activity for 24 hours.", image: "/Images/no-exercise.webp" }
    ],
    faqs: [
      { question: "Is it safe?", answer: "FDA approved, safe in expert hands." },
      { question: "How long does it last?", answer: "3-12 months depending on treatment." }
    ],
    // beforeAfter: { beforeImage: "/Images/before-botox.webp", afterImage: "/Images/after-botox.webp" }
  },
  {
  "title": "Microneedling",
  "slug": "microneedling",
  "short": "Stimulate collagen and rejuvenate your skin naturally.",
  "category": "Cosmetic Procedure",
  "image": "/Images/microneedling.webp",
  "intro": "Microneedling is a minimally invasive treatment that uses tiny needles to create micro-injuries, stimulating collagen and improving skin texture.",
  "whatWeDo": [
    {
      "step": "Consultation",
      "description": "Assess skin condition and determine treatment plan.",
      "image": "/Images/consultation.webp"
    },
    {
      "step": "Microneedling Procedure",
      "description": "Use microneedling device to create controlled micro-injuries.",
      "image": "/Images/procedure.webp"
    },
    {
      "step": "Post-Treatment Care",
      "description": "Apply serums and provide aftercare instructions.",
      "image": "/Images/aftercare.webp"
    }
  ],
  // "surgeryimg": [
  //   "/Images/procedure-offered/Microneedling/s1.webp",
  //   "/Images/procedure-offered/Microneedling/s2.webp"
  // ],
  "procedures": [
    {
      "name": "Collagen Induction Therapy",
      "description": "Stimulates natural collagen production for firmer skin."
    },
    {
      "name": "Acne Scar Reduction",
      "description": "Improves acne scars and smoothens skin texture."
    }
  ],
  "doctor": {
    "name": "Dr Nidhi Patel",
    "experience": "100% Experience",
    "patientSuccess": "100% Patient Success Rate",
    "expertise": "100% Procedures Expertise",
    "knowledge": "100% Knowledge",
    "image": "/Images/procedure/doctor-nidhi.webp"
  },
   surgeryimg:["/Images/procedure-offered/microneedling/s1.webp","/Images/procedure-offered/microneedling/s2.webp"],
  "aftercare": [
    {
      "title": "Avoid Sun Exposure",
      "description": "Use sunscreen and avoid direct sunlight.",
      "image": "/Images/sun.webp"
    },
    {
      "title": "Gentle Skincare",
      "description": "Use mild products to avoid irritation.",
      "image": "/Images/skincare.webp"
    },
    {
      "title": "Stay Hydrated",
      "description": "Drink plenty of water to support healing.",
      "image": "/Images/hydrate.webp"
    }
  ],
  "faqs": [
    {
      "question": "Is microneedling painful?",
      "answer": "A numbing cream is applied; most patients feel minimal discomfort."
    },
    {
      "question": "How many sessions are needed?",
      "answer": "Usually 3-6 sessions give optimal results."
    },
    {
      "question": "When will I see results?",
      "answer": "Initial improvement within weeks; full results in a few months."
    }
  ],
  // "beforeAfter": {
  //   "beforeImage": "/Images/procedure-offered/Microneedling/b.webp",
  //   "afterImage": "/Images/procedure-offered/Microneedling/a.webp"
  // }
}
,
  {
    title: "Skin Rejuvenation",
    slug: "skin-rejuvenation",
    short: "Revitalize dull skin and improve texture.",
    category: "Cosmetic Procedure",
    image: "/Images/skin-rejuvenation.webp",
    intro: "Skin rejuvenation treatments target pigmentation, fine lines, and texture for glowing skin.",
    whatWeDo: [
      { step: "Consultation", description: "Analyze skin and choose appropriate rejuvenation method.", image: "/Images/consult.webp" },
      { step: "Treatment", description: "Apply chemical peels, lasers or light therapies.", image: "/Images/rejuvenation.webp" },
      { step: "Post Care", description: "Provide healing support and skincare regimen.", image: "/Images/post-rejuvenation.webp" }
    ],
    procedures: [
      { name: "Chemical Peels", description: "Exfoliate and renew skin surface." },
      { name: "Laser Therapy", description: "Target pigmentation and fine lines." }
    ],
    doctor: {
      name: "Dr Nidhi Patel",
      experience: "100% Experience",
      patientSuccess: "100% Patient Success Rate",
      expertise: "100% Procedures Expertise",
      knowledge: "100% Knowledge",
      image: "/Images/procedure/doctor-nidhi.webp"
    },
     surgeryimg:["/Images/procedure-offered/lazer_hair/s1.webp","/Images/procedure-offered/lazer_hair/s2.webp"],
    aftercare: [
      { title: "No Sun Exposure", description: "Strict sunscreen use.", image: "/Images/sunscreen.webp" },
      { title: "Hydration", description: "Keep skin moisturized.", image: "/Images/moisture.webp" }
    ],
    faqs: [
      { question: "Is it painful?", answer: "Mild tingling or heat sensation." },
      { question: "When to repeat?", answer: "Every few months as advised." }
    ],
    // beforeAfter: { beforeImage: "/Images/before-rejuvenation.webp", afterImage: "/Images/after-rejuvenation.webp" }
  }

];
export default procedures;